import script from "./ProductReference.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductReference.vue?vue&type=script&setup=true&lang=ts"

import "./ProductReference.vue?vue&type=style&index=0&id=0148788a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0148788a"]])

export default __exports__